import * as EWSAction from './action';
const initialState = {
    ewsCounterparties: [],
    ewsOptinResponse: [],
    ewsPlanList: [],
    ewsPlan: {},
    cpUploadTempate: null,
    cpUploadResponse: null,
    addPlanResponse: null,
    updatePlanInMappingRes: null,
    crawlerStatusResponse: null,
    bulkCrawlerStatusResponse: null,
    reinitiateCrawlerResponse: null,
    dayOfMonth: null,
    runEWSResponse: null,
    ewsDataUploadTemplate: null,
    ewsDataUploadResponse: null,
    corporateCounterpartyListFile: null,
    ewsBulkOptinResponse: null,
    publishReportResponse: null,
    createPublishResponse: null,
    publishData: [],
    publishListResponse: [],
    downloadReportResponse: null,
    ewsReportWithFinancialResponse: null,
    ewsTodoOptinSchedulerResponse: null,
    ewsOptedOutReportResponse: null,
    ewsCorporateNamesDownloadResponse: null,
    ewsCorporateNamesUploadResponse: null,
}
const EWSReducer = (state = initialState, action) => {
    switch (action.type) {
        case EWSAction.FETCH_EWS_COUNTERPARTIES_RESPONSE:
            return state = {
                ...state,
                ewsCounterparties: action.data.length > 0 ? action.data : null
            }
        case EWSAction.FETCH_FILTERED_EWS_COUNTERPARTIES_RESPONSE:
            return state = {
                ...state,
                ewsCounterparties: action.data.length > 0 ? action.data : null
            }
        case EWSAction.OPT_IN_FOR_EWS_RESPONSE:
            return state = {
                ...state,
                ewsOptinResponse: action.data.length > 0 ? action.data : null
            }
        case EWSAction.FETCH_EWS_PLAN_LIST_RESPONSE:
            return state = {
                ...state,
                ewsPlanList: action.data
            }
        case EWSAction.FETCH_EWS_PLAN_RESPONSE:
            return state = {
                ...state,
                ewsPlan: action.data
            }
        case EWSAction.ADD_EWS_PLAN_RESPONSE:
            return state = {
                ...state,
                addPlanResponse: action.data
            }
        case EWSAction.COUNTERPARTY_UPLOAD_TEMPLATE_RESPONSE:
            return state = {
                ...state,
                cpUploadTempate: action.data
            }
        case EWSAction.COUNTERPARTY_UPLOAD_RESPONSE:
            return state = {
                ...state,
                cpUploadResponse: action.data
            }
        case EWSAction.UPDATE_PLAN_IN_MAPPING_RESPONSE:
            return state = {
                ...state,
                updatePlanInMappingRes: action.data
            }
        case EWSAction.CRAWLER_STATUS_REPORT_RESPONSE:
            return state = {
                ...state,
                crawlerStatusResponse: action.data
            }
        case EWSAction.BULK_CRAWLER_STATUS_RESPONSE:
            return state = {
                ...state,
                bulkCrawlerStatusResponse: action.data
            }
        case EWSAction.REINITIATE_CRAWLERS_RESPONSE:
            return state = {
                ...state,
                reinitiateCrawlerResponse: action.data
            }
        case EWSAction.GET_DAY_OF_MONTH_RESPONSE:
            return state = {
                ...state,
                dayOfMonth: action.data
            }
        case EWSAction.UPDATE_DAY_OF_MONTH_RESPONSE:
            return state = {
                ...state,
                dayOfMonth: action.data
            }
        case EWSAction.RUN_EWS_RESPONSE:
            return state = {
                ...state,
                runEWSResponse: action.data
            }
        case EWSAction.EWS_DATA_UPLOAD_TEMPLATE_RESPONSE:
            return state = {
                ...state,
                ewsDataUploadTemplate: action.data
            }
        case EWSAction.EWS_DATA_UPLOAD_RESPONSE:
            return state = {
                ...state,
                ewsDataUploadResponse: action.data
            }
        case EWSAction.CORPORATE_COUNTERPARTY_LIST_RESPONSE:
            return state = {
                ...state,
                corporateCounterpartyListFile: action.data
            }
        case EWSAction.EWS_BULK_OPTIN_RESPONSE:
            return state = {
                ...state,
                ewsBulkOptinResponse: action.data
            }
        case EWSAction.PUBLISH_UNPUBLISH_EWS_REPORT_RESPONSE:
            return state = {
                ...state,
                publishReportResponse: action.data
            }
        case EWSAction.CREATE_EWS_PUBLISH_RESPONSE:
            return state = {
                ...state,
                createPublishResponse: action.data
            }
        case EWSAction.GET_PUBLISH_DATA_RESPONSE:
            return state = {
                ...state,
                publishData: action.data
            }
        case EWSAction.GET_PUBLISH_LIST_RESPONSE:
            return state = {
                ...state,
                publishListResponse: action.data
            }
        case EWSAction.DOWNLOAD_EWS_REPORT_BY_DATE_RESPONSE:
            return state = {
                ...state,
                downloadReportResponse: action.data
            }
        case EWSAction.DELETE_PUBLISH_RESPONSE:
            return state = {
                ...state,
                deletePublishResponse: action.data
            }
        case EWSAction.EWS_REPORT_FINANCIAL_RESPONSE:
            return state = {
                ...state,
                ewsReportWithFinancialResponse: action.data
            }
        case EWSAction.EWS_TODO_OPTIN_SCHEDULER_RESPONSE:
            return state = {
                ...state,
                ewsTodoOptinSchedulerResponse: action.data
            }
        case EWSAction.EWS_OPTED_OUT_REPORT_RESPOSNE:
            return state = {
                ...state,
                ewsOptedOutReportResponse: action.data
            }
        case EWSAction.EWS_CORPORATE_NAMES_DOWNLOAD_RESPOSNE:
            return state = {
                ...state,
                ewsCorporateNamesDownloadResponse: action.data
            }
        case EWSAction.EWS_CORPORATE_NAMES_UPLOAD_RESPOSNE:
            return state = {
                ...state,
                ewsCorporateNamesUploadResponse: action.data
            }
        default: return state
    }
};

export default EWSReducer; 